import React from 'react';
import { MAX_DECIMAL_PLACES } from '../../helpers/constants';
import { getFormattedDate } from '../../helpers/global';

const toDateDisplayValue = value => {
  if (!value) return '';
  if (typeof value === 'string') {
    const datePart = value.slice(0, 10);
    if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) return datePart;
  }
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return getFormattedDate(date);
};

const formatDisplayValue = (rawValue, displayAs) => {
  if (rawValue === null || rawValue === undefined) return '';

  if (displayAs === 'currency-input') {
    const numericValue = typeof rawValue === 'string' ? Number(rawValue) : rawValue;
    if (Number.isNaN(numericValue)) return '';
    return numericValue.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: MAX_DECIMAL_PLACES
    });
  }

  if (displayAs === 'date') {
    return toDateDisplayValue(rawValue);
  }

  return String(rawValue);
};

const StaticInputDisplay = ({
  value,
  displayAs = 'text',
  className = '',
  height,
  inputStyle
}) => {
  const isCurrency = displayAs === 'currency-input';
  const displayValue = formatDisplayValue(value, displayAs);

  return (
    <div
      className={`form-control ${isCurrency ? 'text-start pt-1' : 'form-control-sm midFont'} ${className}`.trim()}
      style={{
        height: height ?? (isCurrency ? '34px' : undefined),
        backgroundColor: '#e9ecef',
        opacity: 1,
        cursor: 'default',
        userSelect: 'none',
        ...inputStyle
      }}
      aria-readonly="true"
    >
      {displayValue}
    </div>
  );
};

export default StaticInputDisplay;
